import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';

const PruebasExamenesWidgetCuadrado = () => {
  const navigate = useNavigate();
  const { user, API, getImageUrl } = useContext(AuthContext);
  const [proximaPrueba, setProximaPrueba] = useState(null);
  const [pruebasPendientes, setPruebasPendientes] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && (user.rol === 'estudiante' || user.rol === 'diploma' || user.rol === 'pastor' || user.rol === 'graduado')) {
      loadProximaPrueba();
    } else {
      setLoading(false);
    }
  }, [user]);

  const loadProximaPrueba = async () => {
    try {
      const response = await axios.get(`${API}/pruebas-examenes/proxima-pendiente`);
      setProximaPrueba(response.data.prueba);
      setPruebasPendientes(response.data.count || 0);
    } catch (error) {
      console.error('Error al cargar próxima prueba pendiente:', error);
      setPruebasPendientes(0);
    } finally {
      setLoading(false);
    }
  };

  // Solo mostrar si hay pruebas pendientes
  if (loading || pruebasPendientes === 0) {
    return null;
  }

  // Navegar directamente a la prueba específica
  const handleClick = () => {
    if (proximaPrueba?.id) {
      navigate(`/app/pruebas-examenes?prueba=${proximaPrueba.id}`);
    } else {
      navigate('/app/pruebas-examenes');
    }
  };

  // Obtener la URL de la imagen
  const getImageSrc = () => {
    if (!proximaPrueba?.imagen_url) return null;
    if (proximaPrueba.imagen_url.startsWith('http')) return proximaPrueba.imagen_url;
    return getImageUrl ? getImageUrl(proximaPrueba.imagen_url) : proximaPrueba.imagen_url;
  };

  const imageSrc = getImageSrc();

  return (
    <div
      onClick={handleClick}
      className="group relative bg-gradient-to-br from-purple-500 via-indigo-500 to-blue-600 rounded-2xl cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl overflow-hidden h-56"
      data-testid="pruebas-examenes-widget"
    >
      {/* Imagen de fondo si existe */}
      {imageSrc && (
        <div className="absolute inset-0">
          <img 
            src={imageSrc}
            alt={proximaPrueba?.titulo || 'Prueba'}
            className="w-full h-full object-cover opacity-30 group-hover:opacity-40 transition-opacity duration-300"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-purple-900/90 via-purple-800/60 to-transparent" />
        </div>
      )}

      {/* Efecto de brillo animado */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
      
      {/* Badge de cantidad en la esquina */}
      {pruebasPendientes > 1 && (
        <div className="absolute top-3 right-3 z-20">
          <div className="bg-white text-purple-600 rounded-full px-2 py-1 text-xs font-bold shadow-lg">
            +{pruebasPendientes - 1} más
          </div>
        </div>
      )}

      {/* Contenido */}
      <div className="relative z-10 h-full flex flex-col p-5 text-white">
        {/* Encabezado con ícono */}
        <div className="flex items-center gap-2 mb-3">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
            <i className="fas fa-clipboard-check text-xl" />
          </div>
          <div>
            <p className="text-xs font-medium opacity-80">Próxima</p>
            <p className="text-sm font-bold">
              {proximaPrueba?.tipo === 'examen' ? 'Examen' : 'Prueba'}
            </p>
          </div>
        </div>

        {/* Título de la prueba */}
        <div className="flex-1 flex flex-col justify-center">
          <h3 className="font-bold text-lg leading-tight line-clamp-2 drop-shadow-lg mb-2">
            {proximaPrueba?.titulo || 'Prueba Pendiente'}
          </h3>
          
          {/* Clase */}
          <p className="text-xs opacity-90 line-clamp-1 mb-2">
            <i className="fas fa-book mr-1" />
            {proximaPrueba?.clase_titulo || 'Sin clase'}
          </p>

          {/* Info adicional */}
          <div className="flex items-center gap-3 text-xs opacity-80">
            {proximaPrueba?.total_preguntas > 0 && (
              <span>
                <i className="fas fa-question-circle mr-1" />
                {proximaPrueba.total_preguntas} preguntas
              </span>
            )}
            {proximaPrueba?.tiempo_limite && (
              <span>
                <i className="fas fa-clock mr-1" />
                {proximaPrueba.tiempo_limite} min
              </span>
            )}
          </div>
        </div>

        {/* Footer con call to action */}
        <div className="mt-auto pt-3 border-t border-white/20">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold opacity-90">
              📝 {pruebasPendientes} {pruebasPendientes === 1 ? 'pendiente' : 'pendientes'}
            </span>
            <span className="text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <i className="fas fa-arrow-right mr-1" />
              Realizar
            </span>
          </div>
        </div>
      </div>

      {/* Decoración de fondo (solo si no hay imagen) */}
      {!imageSrc && (
        <>
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16" />
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12" />
        </>
      )}
    </div>
  );
};

export default PruebasExamenesWidgetCuadrado;
